// extracted by mini-css-extract-plugin
export default {"frame":"LoadingPayment_frame__A07Zz","img":"LoadingPayment_img__ZBIoq","text":"LoadingPayment_text__E7oqf"};